import { styled } from '../../../shared/theming-sc'

const DatasetWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  background: white;
  position: relative;
`

export {
  DatasetWrapper
}
